import React, { useContext, useEffect } from 'react'
import { UserContext } from '~utils/context/UserContext'
import CustomSkeletonLoader from '~components/CustomSkeletonLoader/CustomSkeletonLoader'
import { getDeviceProfile } from '~utils/forgerock'
import { CallbackType } from '@forgerock/javascript-sdk'

interface IUserContextType {
  step
  nextStep
}

const DeviceInput = () => {
  const { step, nextStep } = useContext(UserContext) as IUserContextType
  let deviceProfileCallBackFn

  if (step?.getCallbacksOfType(CallbackType.DeviceProfileCallback)?.length > 0)
    deviceProfileCallBackFn = step?.getCallbackOfType(CallbackType.DeviceProfileCallback)

  useEffect(() => {
    const profileFn = async () => {
      if (deviceProfileCallBackFn) {
        const profile = await getDeviceProfile(deviceProfileCallBackFn)
        deviceProfileCallBackFn?.setInputValue(JSON.stringify(profile))
      }
      nextStep(step)
    }
    profileFn()
  }, [])

  return <CustomSkeletonLoader />
}

export default DeviceInput
